export var ValueAdoption;
(function (ValueAdoption) {
    ValueAdoption["Husband"] = "HUSB";
    ValueAdoption["Wife"] = "WIFE";
    ValueAdoption["Both"] = "BOTH";
})(ValueAdoption || (ValueAdoption = {}));
//# sourceMappingURL=ValueAdoption.js.map